type ErrorMessageInput = Error | string | number | boolean | null | undefined;

export default class NetworkError extends Error {
  isFriendly: boolean;
  code: string;
  context: string | null;

  constructor(message: ErrorMessageInput, { context = null }: { context?: string | null } = {}) {
    const resolvedMessage = message instanceof Error ? message.message : String(message);
    super(resolvedMessage);
    this.isFriendly = false;
    this.code = 'ERRNETWORK';
    this.context = context;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
